
export enum DateErrorType {
    None = 0b0,
    Avverkningsanmalan = 0b1,
    Certifikat = 0b10,
    Kontrakt = 0b100,
    All = 0b11
}
